import React from "react";
import style from "./dressingAppearance.module.scss";
import { firstLetterCaps, signedLockedAccess } from "../../../../utils";
import { PERMISSIONS } from "../../../../constants/permissions";
import { Row } from "../../../secondary/Row/Row";
import { EditActionButton } from "../../../secondary/EditActionButton/EditActionButton";

export const DressingAppearanceViewMode = ({ resp, assessmentDetails, onEdit, hasPermission }) => (
  <>
    <div className={`${style.form_container}`}>
      <div className={style.form_actions}>
        <EditActionButton
          onClick={onEdit}
          disabled={!hasPermission(PERMISSIONS.TREATMENT_EDIT) || !signedLockedAccess(assessmentDetails?.assessmentStage)}
        />
      </div>

      <section className={style.form_section}>
        <div className={style.form_section_header}>
          <span className={style.form_section_title}>Dressing Appearance</span>
        </div>
        <div className={style.form_section_body}>
          <Row label="Dressing Appearance" value={firstLetterCaps(resp?.dressingAppearance)} />
        </div>
      </section>
    </div>
  </>
);
